module.exports = __webpack_public_path__ + "static/media/google_17.b805e550.svg";